
export function getCurrentTab() {
    return localStorage.getItem('current_tab');
  }
  